import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import ParametersTableHeader from '../../Blocks/ParametersTableHeader';
import ParametersTypeValue from '../../Blocks/ParametersTypeValue';
import ReturnTypeValue from '../../Blocks/ReturnTypeValue';

import {
    FormatDate
} from '../../../../../libraries/Tool';

function Vi(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="if">
                1.&nbsp;<span className="material-symbols-outlined">call_split</span>&nbsp;{translate('if')}
            </Typography>
            <p><strong>{translate('if')}</strong> là hành động phân nhánh quá trình xử lý theo điều kiện đã chỉ định. Nếu điều kiện là đúng, hãy thực hiện hành động được xác định trong khối.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('condition')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là điều kiện.</td>
                                <td></td>
                            </tr>
                            
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('condition')}</span>
                            <div><span className='parameter-fx'>fx(<span className='parameter-fx-value'>GetCurrentDate(7 , "YYYY-MM-DD")</span>)</span>&nbsp;=&nbsp;"{FormatDate(new Date(), "yyyy-MM-dd")}"</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="loop">
                2.&nbsp;<span className="material-symbols-outlined">cached</span>&nbsp;{translate('loop')}
            </Typography>
            <p><strong>{translate('loop')}</strong> là hành động lặp lại quy trình với số lần được chỉ định.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là số lần lặp hiện tại (bắt đầu từ 0).</td>
                                <td>$i_1</td>
                            </tr>
                            <tr>
                                <td>{translate('times')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>Là số lần lặp lại.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="number" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$i_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('condition')}</span>
                            <div>3</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>0</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>1</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>2</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="forearch">
                3.&nbsp;<span className="material-symbols-outlined">repeat</span>&nbsp;{translate('forearch')}
            </Typography>
            <p><strong>{translate('forearch')}</strong> là hành động thực hiện lặp lại quy trình cho từng phần tử của mảng.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là giá trị của từng phần tử trong mảng.</td>
                                <td>$item_1</td>
                            </tr>
                            <tr>
                                <td>{translate('iterable')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="array" />
                                </td>
                                <td>Là mảng cần duyệt.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="any" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$item_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('iterable')}</span>
                            <div>{`["red", "green", "blue"]`}</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>red</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>green</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>blue</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="breakif">
                4.&nbsp;<span className="material-symbols-outlined">do_not_disturb_alt</span>&nbsp;{translate('breakif')}
            </Typography>
            <p><strong>{translate('breakif')}</strong> là hành động thoát khỏi Loop/ForEarch, đặt nó bên trong khối Loop/ForEach. Nếu điều kiện đã chỉ định là đúng, hãy thoát khỏi khối vòng lặp (Loop/ForEach) và chuyển sang tác vụ tiếp theo bên ngoài khối. Nếu các phần lặp được lồng vào nhau, hãy thoát khỏi khối lặp trong cùng.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('condition')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là điều kiện.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('condition')}</span>
                            <div><span className='parameter-fx'>fx(<span className='parameter-fx-value'>GetCurrentDate(7 , "YYYY-MM-DD")</span>)</span>&nbsp;=&nbsp;"{FormatDate(new Date(), "yyyy-MM-dd")}"</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="wait">
                5.&nbsp;<span className="material-symbols-outlined">hourglass_top</span>&nbsp;{translate('wait')}
            </Typography>
            <p><strong>{translate('wait')}</strong> là hành động chờ đợi để tiến hành hành động tiếp theo.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('timeout')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>Là thời gian chờ đợi (tính bằng đơn vị mili giây).</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('condition')}</span>
                            <div><span className='parameter-fx'>fx(<span className='parameter-fx-value'>GetCurrentDate(7 , "YYYY-MM-DD")</span>)</span>&nbsp;=&nbsp;"{FormatDate(new Date(), "yyyy-MM-dd")}"</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="runjavascript">
                6.&nbsp;<span className="material-symbols-outlined">javascript</span>&nbsp;{translate('runjavascript')}
            </Typography>
            <p><strong>{translate('runjavascript')}</strong> là hành động chạy JavaScript bên trong một hành động.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là giá trị trả về sau khi thực thi mã JavaScript nếu có.</td>
                                <td>$runJavascript_1</td>
                            </tr>
                            <tr>
                                <td>{translate('code')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là mã JavaScript bạn muốn chạy.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="any" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$runJavascript_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('code')}</span>
                            <div>let a = 1; let b = 2; return a + b;</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>3</div>
                        </div>
                    </div>
                </li>
            </ul>
        </Box>
    );
}
export default withTranslate(Vi);